module.exports = __webpack_public_path__ + "img/outsourcing-company-vs-recruiting-agency.39d460de.webp";